module.exports = __webpack_public_path__ + "static/backgroundcourses-1-53867ff0cb224edd0e41cdd5b58fb2f7.jpg";